<template>
	<div>
		<label
			>{{ text }}
			<span v-show="isMandatory" class="asterik">*</span>
		</label>

		<div class="newmodalinputbox position-relative w-100">
			<!-- Date Picker -->
			<DatePicker
				v-if="!showDateTime"
				ref="datePickerRef"
				placement="bottom-start"
				v-model="dateValue"
				:editable="false"
				type="date"
				value-type="format"
				placeholder="Select"
				format="DD-MM-YYYY"
				@input="selectDate"
				:disabled="disabled"
				:class="{ errorClass: validation }"
				:append-to-body="false"
			/>

			<!-- Date Time Picker -->
			<datetime
				v-if="showDateTime"
				:placeholder="placeholder"
				ref="startDate"
				class="datetimeconfig"
				type="datetime"
				use12-hour
				@input="selectDate"
				:disabled="disabled"
				:min-datetime="computedMinDateTime"
				v-model="dateTimeValue"
				:class="{ errorClass: validation }"
			/>
		</div>
	</div>
</template>

<script>
import { DateTime } from "luxon";

export default {
	props: {
		value: {
			type: String,
			default: null,
		},
		text: {
			type: String,
			default: "Label",
		},
		isMandatory: {
			type: Boolean,
			default: false,
		},
		validation: {
			type: Boolean,
			default: false,
		},
		showDateTime: {
			type: Boolean,
			default: false,
		},
		minDateTime: {
			type: String,
			default: DateTime.now().toISO(),
		},
		datetimeValue: {
			type: String,
			default: null,
		},
		datetimeValidation: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: "Select",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			dateValue: this.value,
			dateTimeValue: this.datetimeValue,
		};
	},
	watch: {
		value(newVal) {
			this.dateValue = newVal;
		},
		datetimeValue(newVal) {
			this.dateTimeValue = newVal;
		},
		dateTimeValue(newVal) {
			this.$emit("update:datetimeValue", newVal);
		},
	},
	computed: {
		computedMinDateTime() {
			return this.minDateTime || DateTime.now().toISO();
		},
	},
	methods: {
		selectDate(val) {
			console.log("the value is", val);
			this.$emit("input", val);
		},
	},
};
</script>

<style>
.newmodalinputbox .mx-input {
	padding: 10px 14px;
	background: #ffffff;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	color: #333333;
	height: 40px;
}
.newmodalinputbox img {
	position: absolute;
	right: 10px;
	top: 12px;
}
.mx-datepicker {
	width: 100%;
}

.newmodalinputbox .mx-icon-calendar,
.newmodalinputbox .mx-icon-clear {
	cursor: pointer;
}

.newmodalinputbox .mx-input-wrapper .mx-input:hover,
.newmodalinputbox .mx-input:focus {
	border-color: #d0d5dd;
}

.newmodalinputbox .mx-input-wrapper .mx-input:hover,
.newmodalinputbox .mx-input:focus {
	border-color: #d0d5dd;
}
.newmodalinputbox .mx-input:disabled {
	background-color: #f5f5f5;
	cursor: not-allowed;
}
.newmodalinputbox .mx-input::placeholder {
	opacity: 1;
}
.datetimeconfig input {
	width: 100%;
	height: 40px;
	border-radius: 8px;
	border: 1px solid #ced4da;
	padding-inline: 14px;
}
</style>
